import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import axios from '../utils/axios';
import { setCredentials, logoutState, selectCurrentRefreshToken } from '../redux/slices/authSlice'; // Import the necessary action creators from your slice
import { BaseQueryApi } from '@reduxjs/toolkit/dist/query/baseQueryTypes';

const refreshToken = async (dispatchOrApi: Dispatch<AnyAction> | BaseQueryApi): Promise<{ accessToken: string; refreshToken: string; user: any; roles: number[] } | null> => {
    // Check if it's a dispatch function or BaseQueryApi object
    //@ts-ignore
    const isDispatch = typeof dispatchOrApi.dispatch === 'undefined';
    //@ts-ignore
    const dispatch = isDispatch ? (dispatchOrApi as Dispatch<AnyAction>) : dispatchOrApi.dispatch;

    try {
        const response = await axios.get(`/sessions/refresh`, {
            withCredentials: true,
        });

        // const refreshTokenData = Cookies.get('refreshToken');

        // console.log('Refresh in Cookies', refreshTokenData);
        // console.log('response', response.data);

        const userData = await jwtDecode(response.data?.accessToken);

        // console.log('UserData', userData);

        const updatedCredentials = {
            accessToken: response.data.accessToken,
            refreshToken: response.data.refreshToken,
            user: userData ? userData : {},
            //@ts-ignore
            roles: [userData?.roleId ? userData.roleId : 2001],
        };

        dispatch(setCredentials(updatedCredentials));

        return updatedCredentials;
    } catch (error) {
        dispatch(logoutState());
        return null;
    }
};

export default refreshToken;